
  Vue.component('dynamic-form', {
    props: {
      id: { type: String, required: true },
      fields: { type: Array, required: true },
      apiLoadEndPoint: { type: String },
      apiSaveEndPoint: { type: String },
      defaultFieldValue: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        childrenInterface: [],
        checkValidation: false,
        fieldsValue: {},
        originalFieldsValue: {},
        error: false
      }
    },
    template: '#dynamic-form',
    computed: {},
    watch: {
      defaultFieldValue: {
        handler(newValue, oldValue) {
          const self = this
          const retVal = {}
          self.fields.forEach(item => {
            retVal[item.fieldName] = item.value
              ? item.value
              : self.defaultFieldValue[item.fieldName]
              ? self.defaultFieldValue[item.fieldName]
              : ''
          })

          self.fieldsValue = retVal
          self.originalFieldsValue = { ...retVal }
        }
      },
      fieldsValue: {
        handler(newValue, oldValue) {
          // console.log(newValue, oldValue)
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      itemInput(item) {
        // this.$set(fieldsValue, item.fieldName, item.value)
        this.fieldsValue[item.fieldName] = item.value
        this.$emit('change', item)
      },
      getChildInterface(childInterface) {
        this.childrenInterface.push(childInterface)
      },
      validate() {
        let valid = true
        this.childrenInterface.forEach(item => {
          if (!item.validate()) {
            if (valid) {
              window.scrollTo({
                behavior: 'smooth',
                top: window.scrollY + item.containerRef.getBoundingClientRect().top - 105
              })
              valid = false
            }
          }
        })
        return valid
      },

      fieldsAreChange() {
        return JSON.stringify(this.fieldsValue) !== JSON.stringify(this.originalFieldsValue)
      },
      getFieldValue(fieldName) {
        const retVal = this.fieldsValue[fieldName]
        return retVal
      },
      emitInterface() {
        this.$emit('interface', {
          key: this.id,
          validate: () => this.validate(),
          getValues: () => this.fieldsValue,
          fieldsAreChange: () => this.fieldsAreChange()
        })
      }
    },
    mounted() {
      this.emitInterface()

      const self = this
      const retVal = {}
      if (this.apiLoadEndPoint) {
        axios
          .get(this.apiLoadEndPoint)
          .then(response => {
            const { data } = response
            self.fields.forEach(item => {
              retVal[item.fieldName] =
                data.hasOwnProperty(item.fieldName) && data[item.fieldName]
                  ? data[item.fieldName]
                  : item.value
                  ? item.value
                  : self.defaultFieldValue[item.fieldName]
                  ? self.defaultFieldValue[item.fieldName]
                  : ''
            })

            self.fieldsValue = retVal
            self.originalFieldsValue = { ...retVal }
          })
          .catch(error => {
            self.error = true
          })
          .then(() => {
            // always executed
          })
      }
      if (!Object.keys(retVal).length) {
        self.fields.forEach(item => {
          retVal[item.fieldName] = item.value
            ? item.value
            : self.defaultFieldValue[item.fieldName]
            ? self.defaultFieldValue[item.fieldName]
            : ''
        })

        self.fieldsValue = retVal
        self.originalFieldsValue = { ...retVal }
      }
    }
  })
